import { watch } from "vue";
import { eventBus, GlobalEvents } from "@allwyn/utils/global-events";
import { ngFrameworkLoaded } from "../ng-integration";
import { useNgSession } from "../ng-session";

/**
 * Invokes the given function only when the user is logged in.
 * If already logged in, executes immediately. Otherwise, opens the login modal
 * and waits for a successful login (resolves with the function result) or modal close (resolves with null).
 * The watcher and event listener are cleaned up after the first resolution/rejection.
 */
export const invokeWithLogin = async <T>(fn: () => T): Promise<T | null> => {
    const { isLoggedIn } = useNgSession();
    await ngFrameworkLoaded();

    if (isLoggedIn.value) {
        return await fn();
    }

    ng_fw.showLogin();

    return new Promise((resolve) => {
        const stopWatch = watch(isLoggedIn, async (loggedIn) => {
            if (loggedIn) {
                cleanup();
                resolve(await fn());
            }
        });

        function cleanup() {
            stopWatch?.();
            eventBus.off(GlobalEvents.WebLoginAborted, onAborted);
        }

        function onAborted() {
            cleanup();
            resolve(null);
        }

        eventBus.on(GlobalEvents.WebLoginAborted, onAborted);
    });
};
